import { Switch } from '~/components/ui/switch'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type SwitchFieldProps = React.ComponentProps<typeof Switch> & Omit<FieldProps, 'children' | 'error'>

export function SwitchField({ label, id, optional, className, ...props }: SwitchFieldProps) {
  const field = useFieldContext<boolean>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message

  return (
    <Field
      label={label}
      id={id}
      optional={optional}
      required={props.required}
      error={errorMessage}
      className={className}
      labelClassName="flex-row justify-between items-center"
    >
      <Switch
        {...props}
        size="lg"
        id={field.name}
        name={field.name}
        onBlur={field.handleBlur}
        checked={field.state.value}
        onCheckedChange={field.handleChange}
        aria-invalid={errorMessage !== undefined}
      />
    </Field>
  )
}
